import {Injectable} from '@angular/core';
import {DATE_FORMAT, ngbDateToDayjs} from '@common/const/form.constants';
import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';

@Injectable()
export class TmwDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = dayjs(value);
      return {
        day: date.date(),
        month: date.month() + 1,
        year: date.year(),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? ngbDateToDayjs(date)?.format(DATE_FORMAT) : null;
  }
}
